import {
    AfterViewInit,
    Component,
    Input, OnDestroy,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { ActiveDialog } from '@monsido/angular-shared-components';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { TrapFocusService } from '@client/app/modules/trap-focus/trap-focus.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'dialog-upgrade-wrapper',
    template: `
        <div class="mon-dialog"
             role="dialog"
             [attr.id]="id"
             tabindex="-1"
             aria-label="Exit overlay"
             [ngStyle]="{'z-index': zindex}"
             (keyup.escape)="closeDialog()"
             [ngClass]="[classes, 'mon-dialog-size-' + size ]">
            <span [ngStyle]="{'z-index': zindex}"
                  class="mon-dialog-close"
                  [attr.aria-labelledby]="id"
                  role="button"
                  tabindex="0"
                  (click)="closeDialog()"></span>
            <ng-template #bodyWrapper
                         aria-label="Opening overlay"
                         role="alert"></ng-template>
        </div>
    `,
    providers: [
        ActiveDialog,
    ],
    standalone: false,
})
export class DialogUpgradeWrapperComponent implements AfterViewInit, OnDestroy {
    @Input() size = 'md';
    @Input() zindex = 0;
    @Input() classes = '';
    @Input() id = '';
    @Input() monDialogId = '';
    @Input() close: any = null;
    @Input() useStandardTemplate = false;
    @Input() setForm: any = null;
    @Input() setCloseValidation?: any = null;
    @Input() unsavedMsg;
    @Input() unsavedTitle;
    @Input() body: any = '';
    @Input() header: any = '';
    @Input() data: any = {};
    @Input() onBeforeClose: any = null;
    @Input() manualFocus = false;

    @ViewChild('bodyWrapper', { read: ViewContainerRef }) bodyWrapper!: ViewContainerRef;
    subscriptions: Subscription[] = [];

    constructor (
        private monDialog: MonDialog,
        private trapFocusService: TrapFocusService,
    ) {}

    ngAfterViewInit () {
        const component = this.bodyWrapper.createComponent(this.body);
        const componentInstance = component.instance as any;
        for (const key of Object.keys(this.data)) {
            // Compatibility with signal inputs
            if (
                typeof componentInstance[key] === 'function' &&
                componentInstance[key].name === 'inputValueFn'
            ) {
                component.setInput(key, this.data[key]);
                continue;
            }

            componentInstance[key] = this.data[key];
        }

        if (!this.manualFocus) {
            const focus = this.trapFocusService.create('#' + this.id, {
                escapeDeactivates: false,
                allowOutsideClick: true,
                initialFocus: false,
            });
            this.monDialog.setFocus(this.id, focus);
        }

        // Middleware for setting form into MonDialog service
        // We only want to set the form if the form had been touched
        componentInstance.setForm = (payload) => {
            if (!payload.form) {
                return;
            }
            const sub = payload.form?.statusChanges?.subscribe(() => {
                if (!payload.form.touched) {
                    return;
                }
                this.monDialog.setForm(payload);
            });
            this.subscriptions.push(sub);
        };
    }

    ngOnDestroy () {
        for (const sub of this.subscriptions) {
            sub?.unsubscribe();
        }
    }

    closeDialog () {
        this.monDialog.close(this.id, undefined);
    }
}
